import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { CreativeContext } from "./CreativeCreation";
import { buildProductPayload } from "./WebView/utils/ProductForm";
import useSpecial from "./WebView/utils/useSpecial";


const CTA_TYPES = [
  { value: "", label: "Regular URL" },
  { value: "job_listings", label: "Jobs Listings" },
  { value: "business_listings", label: "Business Listings" },
];

const JOB_LISTING_TYPES = [
  { value: "employee", label: "Employee" },
  { value: "employer", label: "Employer" },
  { value: "custom", label: "Custom" }
];

function Speicals({
  company,
  companyName,
  handleshow,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();
  const { setPreview } = useContext(CreativeContext);

  const [image, setImage] = useState("");
  const [imgurl, setImgurl] = useState("");
  const [bannerImage, setBannerImage] = useState("");
  const [bannerImgUrl, setBannerImgUrl] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  const { SpecialForm, schema } = useSpecial({
    control,
    register,
    editdata: editdata || null,
    setValue,
    errors,
  });

  const watchTitle = watch("title", editdata?.head_line || "");
  const watchDescription = watch("description", editdata?.description || "");
  const watchButtonEnabled = watch(
    "buttonEnabled",
    editdata?.button_enabled === 1
  );
  const watchButtonText = watch("buttonText", editdata?.button_text || "");
  const watchCtaUrl = watch("ctaUrl", editdata?.button_link || "");
  const watchCtaType = watch("cta_type", editdata?.cta_type || "");
  const watchJobListingType = watch("job_listing_type", editdata?.gallery?.job_listing_type || "");
  const watchSpecial = watch("special", editdata?.special === 1);
  const watchInappButtonText = watch("in_app_button_text", editdata?.in_app_button_text || "");
  const watchDesignType = watch("design_type", editdata?.design_type || "1");
  const watchEventDate = watch("specials_event_date", editdata?.gallery?.event_date || "");
  const watchLocation = watch("location", editdata?.gallery?.location || "");


  useEffect(() => {
    setPreview(prev => ({
      ...prev,
      sub_type: "specials",
      head_line: watchTitle,
      description: watchDescription,
      img_url: imgurl || editdata?.img_url || "",
      button_enabled: watchSpecial ? true : watchButtonEnabled,
      button_text: watchSpecial
        ? watchInappButtonText
        : watchButtonEnabled ? watchButtonText : "",
      button_link: watchSpecial ? "" : watchButtonEnabled ? watchCtaUrl || "" : "",
      gallery: {
        design_type: watchDesignType,
        cta_type: watchCtaType,
        event_date: watchEventDate,
        location: watchLocation,
      },
      video_urls: bannerImgUrl || editdata?.video_urls || "",
    }));
  }, [
    watchTitle,
    watchDescription,
    watchButtonEnabled,
    watchButtonText,
    watchCtaUrl,
    watchSpecial,
    watchInappButtonText,
    imgurl,
    setPreview,
    bannerImgUrl,
    watchDesignType,
  ]);

  useEffect(() => {
    if (flag === "edit") {
      setPreview(prev => ({
        ...prev,
        sub_type: editdata?.sub_type || "specials",
        img_url: editdata?.img_url || editdata?.img_urls || "",
        video_urls: editdata?.video_urls || "",
        description: editdata?.description || "",
        head_line: editdata?.head_line || "",
        button_enabled: editdata?.button_enabled === 1,
        button_text: editdata?.button_text || "",
        button_link: editdata?.button_link || "",
        design_type: ''+editdata?.gallery?.design_type || "1",
      }));
      setImgurl(editdata?.img_url || editdata?.img_urls || "");
      setBannerImgUrl(editdata?.video_urls || "");
      setValue("special", editdata?.special === 1);
      setValue("buttonEnabled", editdata?.button_enabled === 1);
      setValue("click_per_day", !!editdata?.click_per_day);
      setValue("design_type", ''+editdata?.gallery?.design_type || '1');
      setValue("cta_type", ''+editdata?.gallery?.cta_type || "");
      setValue("job_listing_type", editdata?.gallery?.job_listing_type || "");
      setValue("video_urls", editdata?.video_urls || "");
    }
  }, [flag, editdata, setPreview]);

  const handleImage = (e) => {
    try {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/webp" ||
          file.type === "image/png"
        ) {
          setImage(file);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted");
          setValue("image", "");
        }
      } else if (flag === "edit") {
        setImgurl(editdata?.img_urls || "");
        setPreview(prev => ({ ...prev, img_urls: editdata?.img_urls || "" }));
      } else {
        setImgurl("");
        setPreview(prev => ({ ...prev, img_urls: "" }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formData = new FormData();
  formData.append("files", image);

  const uploadImage = async () => {
    try {
      const res = await api({
        url: `/upload/brandImage`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res?.code === 200) {
        setImgurl(res?.data?.data);
        setPreview(prev => ({ ...prev, img_urls: res?.data?.data }));
      } else {
        setValue("image", null);
        setImage("");
        Toast("error", res?.data?.message || "Image upload failed");
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (image) uploadImage();
  }, [image]);

  const handleBannerImage = (e) => {
    try {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/webp" ||
          file.type === "image/png"
        ) {
          setBannerImage(file);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted");
          setValue("bannerImage", "");
        }
      }
      else if (flag === "edit") {
        setBannerImgUrl(editdata?.video_urls || "");
      } else {
        setBannerImgUrl("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const uploadBannerImage = async (file) => {
    try {
      const bannerFormData = new FormData();
      bannerFormData.append("files", file);
      const res = await api({
        url: `/upload/brandImagefull`,
        method: "POST",
        responseType: "json",
        data: bannerFormData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res?.code === 200) {
        setBannerImgUrl(res?.data?.data);
      } else {
        setValue("bannerImage", null);
        setBannerImage("");
        Toast("error", res?.data?.message || "Banner image upload failed");
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (bannerImage) uploadBannerImage(bannerImage);
  }, [bannerImage]);

  const onSubmit = async (data) => {
    if (!data.special && !data.buttonEnabled) {
      Toast("error", "Please enable at least one: Button or In-App Form Configuration");
      return;
    }
    if (flag === "add") {
      handlesubmit(true);
      const obj = {
        company_id: company,
        company_name: companyName,
        creative_name,
        creative_type,
        sub_type: subtype,
        head_line: data.title,
        description: data.description,
        img_urls: imgurl,
        button_enabled: data.special ? false : (data.buttonEnabled ? true : false),
        button_text: data.special ? "" : (data.buttonEnabled ? data.buttonText : ""),
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        schema,
        special:data.special,
             gallery:{ event_date:data.specials_event_date,
        location:data.location,cta_type: data.cta_type,design_type: data.design_type,
        job_listing_type: data.cta_type === "job_listings" ? (data.job_listing_type || "") : ""},
        button_link: data.special ? "" : (data.buttonEnabled ? data.ctaUrl || "" : ""),
        video_urls: bannerImgUrl,
        
        click_per_day: data.click_per_day,
        ...buildProductPayload(data),
      };
      if (creative_name !== "") {
        try {
          const res = await api({
            url: `/creatives/widget/specials`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", "Creative Created Successfully");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res?.data?.message || "Create failed");
          }
        } catch (error) {
          console.error(error);
          if (error.response?.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      const obj = {
        creative_id: editdata?.creative_id,
        creative_name: creative_name,
        head_line: data.title,
        description: data.description,
        button_enabled: data.special ? false : (data.buttonEnabled ? true : false),
        button_text: data.special ? "" : (data.buttonEnabled ? data.buttonText : ""),
        button_link: data.special ? "" : (data.buttonEnabled ? data.ctaUrl || "" : ""),
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        schema,
        special:data.special,
         gallery:{ event_date:data.specials_event_date,
        location:data.location,cta_type: data.cta_type,design_type: data.design_type,
        job_listing_type: data.cta_type === "job_listings" ? (data.job_listing_type || "") : ""},
        video_urls: bannerImgUrl !== "" ? bannerImgUrl : editdata?.video_urls || "",
          amount: data.amount_type === 'multiple' ? 0 : (Number(data.amount) || 0),
        product_amounts: data.amount_type === 'multiple'
          ? (data.product_amounts || []).map((p) => ({ title: p.title, amount: Number(p.amount) || 0 }))
          : [],
        place:data.place||null,
        event_date:data.event_date,
        product_img_urls:data.productImage,
        transcation_type: data.transcation_type,

        click_per_day: data.click_per_day,
        ...buildProductPayload(data),
      };
      obj.img_urls = imgurl !== "" ? imgurl : editdata?.img_urls || editdata?.img_url;
      try {
        const res = await api({
          url: `/creatives/widget/edit_specials`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", "Creative Edited Successfully");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res?.data?.message || "Edit failed");
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status === 401) navigate("/");
      }
    }
  };

  useEffect(() => {
    if (watchDesignType === "1") {
      setValue("img_url", "");
      setValue("img_urls", "");
      setImgurl("");
    } else {
      setValue("video_urls", "");
      setValue("title", "");
      setValue("description", "");
      setValue("location", "");
      setValue("specials_event_date", "");
      setBannerImgUrl("");
    }
  }, [watchDesignType]);

  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="row">
          <section className="col-12">{console.log(watchDesignType, errors)}

            <div className="row mb-3">
              <div className="d-flex gap-2">
                <input className="form-check-input" type="radio" name="design_type" checked={watchDesignType === "1"} value={1} {...register("design_type", { required: "Design type is required" })} />Story
                <input className="form-check-input" type="radio" name="design_type" checked={watchDesignType === "2"} value={2} {...register("design_type", { required: "Design type is required" })} />Image
              </div>
            </div>
            {errors.design_type && (
              <p className="text-red-600">{errors.design_type.message}</p>
            )}
            {/* image type only this image is required */}
            {watchDesignType === "2" && (
              <>
                <div className="row mb-3">
              <div className="col-12">
                <label className="form-label">Upload Image (300X260)</label>
                <input
                  type="file"
                  className="form-control"
                  {...register("image", {
                    required: watchDesignType === "2" ? editdata?.img_url || editdata?.img_urls ? false : true : false,
                    onChange: (e) => handleImage(e),
                  })}
                />
                {!editdata?.img_url && !editdata?.img_urls && errors.image && (
                  <p className="text-red-600">Image is required</p>
                )}
                <p>{imgurl || editdata?.img_url || editdata?.img_urls}</p>
              </div>
            </div>
            </>
            )}

            {watchDesignType === "1" && (
              <>
              {/** Story type  these fields are required */}
            <div className="row mb-3">
              <div className="col-12">
                <label className="form-label">Upload Banner Image (90X260)</label> {/** story type image is required */}
                <input
                  type="file"
                  className="form-control"
                  {...register("bannerImage", {
                    required: watchDesignType === "1" ? editdata?.video_urls ? false : true : false,
                    onChange: (e) => handleBannerImage(e),
                  })}
                />
                {!editdata?.video_urls && errors.bannerImage && (
                  <p className="text-red-600">Banner image is required</p>
                )}
                <p>{bannerImgUrl || editdata?.video_urls}</p>
              </div>
            </div>
            {/* story type Title is required */}
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Title</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.head_line || ""}
                  placeholder="Enter title"
                  {...register("title", {
                    validate: (value) => {
                      if (watchDesignType !== "1") return true;
                      return value?.trim() ? true : "Title is required";
                    },
                    maxLength: { value: 75, message: "Title cannot exceed 75 characters" }
                  })}
                />
                {errors.title && (
                  <p className="text-red-600">{errors.title.message}</p>
                )}
              </div>
            </div>

            {/* story type Description is required */}
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Description - 350* chars</label>
                <textarea
                  className="form-control"
                  rows="3"
                  defaultValue={editdata?.description || ""}
                  placeholder="Enter description"
                  {...register("description", {
                    validate: (value) => {
                      if (watchDesignType !== "1") return true;
                      return value?.trim() ? true : "Description is required";
                    },
                    maxLength: { value: 350, message: "Description cannot exceed 350 characters" }
                  })}
                />
                {errors.description && (
                  <p className="text-red-600">{errors.description.message}</p>
                )}
              </div>
            </div>

            {/** story type Location is not required*/}
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Location </label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.gallery?.location || ""}
                  placeholder="Hyderabad"
                  {...register("location")}
                />
              </div>
              {errors.location && (
                  <p className="text-red-600">{errors.location.message}</p>
                )}
            </div>

            {/** story type Date is not required */}
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Date</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.gallery?.event_date || ""}
                  {...register("specials_event_date")}
                />
              </div>
              {errors.specials_event_date && (
                  <p className="text-red-600">{errors.specials_event_date.message}</p>
                )}
            </div>
            </>
            )}
            

        

            <div className="row mb-2">
              <div className="col">
                <label className="form-label">Impression URL - Primary</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={
                    editdata.impression_tracking_url
                      ? editdata.impression_tracking_url.primary
                      : null
                  }
                  {...register("impurl", {
                    required: false,
                    pattern: {
                      value:
                        /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                      message: "Enter a Valid URL",
                    },
                  })}
                />
                {errors.impurl && (
                  <p className="text-red-600">{errors.impurl.message}</p>
                )}
              </div>
              <div className="col">
                <label className="form-label">Impression URL - Secondary</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={
                    editdata.impression_tracking_url
                      ? editdata.impression_tracking_url.secondary
                      : null
                  }
                  {...register("impurl1", {
                    required: false,
                    pattern: {
                      value:
                        /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                      message: "Enter a Valid URL",
                    },
                  })}
                />
                {errors.impurl1 && (
                  <p className="text-red-600">{errors.impurl1.message}</p>
                )}
              </div>
            </div>

            {!watchSpecial && (
              <div className="row mb-2">
                <div className="col">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="ButtonEnabled"
                      defaultChecked={true}
                      {...register("buttonEnabled")}
                    />
                    <label htmlFor="ButtonEnabled" className="form-check-label">
                      Enable Button
                    </label>
                  </div>
                </div>
              </div>
            )}

            {!watchSpecial && watchButtonEnabled && (
              <>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Button Text</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata?.button_text || ""}
                      placeholder="e.g. Call Now, Visit Website, Get Offer"
                      {...register("buttonText", {
                        required: "Button text is required",
                      })}
                    />
                    {errors.buttonText && (
                      <p className="text-red-600">{errors.buttonText.message}</p>
                    )}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">CTA URL</label>
                    <div className="d-flex gap-2">
                      {CTA_TYPES.map(({ value, label }) => (
                        <label key={value || "regular"} className="d-flex align-items-center gap-1">
                          <input
                            className="btn btn-primary btn-sm"
                            type="radio"
                            value={value}
                            checked={watchCtaType === value}
                            {...register("cta_type", { required: "CTA type is required" })}
                            onClick={() => {
                              setValue("cta_type", value);
                              setValue("ctaUrl", "");
                              if (value !== "job_listings") setValue("job_listing_type", "");
                            }}
                          />
                          {label}
                        </label>
                      ))}
                    </div>
                    {watchCtaType === "job_listings" && (
                      <div className="mt-2 mb-2">
                        <label className="form-label">Job Listing Type</label>
                        <div className="d-flex gap-2">
                          {JOB_LISTING_TYPES.map(({ value, label }) => (
                            <label key={value} className="d-flex align-items-center gap-1">
                              <input
                                className="btn btn-primary btn-sm"
                                type="radio"
                                value={value}
                                checked={watchJobListingType === value}
                                {...register("job_listing_type", {
                                  required: watchCtaType === "job_listings" ? "Job listing type is required" : false,
                                })}
                                onClick={() => {
                                  setValue("job_listing_type", value);
                                  if (value !== "custom") setValue("ctaUrl", "");
                                }}
                              />
                              {label}
                            </label>
                          ))}
                        </div>
                        {errors.job_listing_type && (
                          <p className="text-red-600">{errors.job_listing_type.message}</p>
                        )}
                      </div>
                    )}
                    {(() => {
                      const isJobCustom = watchCtaType === "job_listings" && watchJobListingType === "custom";
                      const urlEnabled = !watchCtaType || isJobCustom;
                      return (
                        <input
                          type="text"
                          className="form-control"
                          disabled={!urlEnabled}
                          defaultValue={editdata?.button_link || ""}
                          placeholder="e.g. https://example.com, https://wa.me/91xxxxxxxxxx, tel:+91xxxxxxxxxx"
                          {...register("ctaUrl", {
                            required: urlEnabled ? "CTA URL is required" : false,
                          })}
                        />
                      );
                    })()}
                    {errors.ctaUrl && (
                      <p className="text-red-600">{errors.ctaUrl.message}</p>
                    )}
                  </div>
                </div>

                <div className="row mb-2">
                  <div className="col">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="click_per_day"
                        defaultChecked={!!editdata?.click_per_day}
                        {...register("click_per_day")}
                      />
                      <label htmlFor="click_per_day" className="form-check-label">
                        custid mapping
                      </label>
                    </div>
                  </div>
                </div>
              </>
            )}

            {!watchButtonEnabled && SpecialForm()}

            <div className="my-3 text-end">
              <button type="submit" className="btn btn-primary">
                Save Creative
              </button>
            </div>
          </section>
        </div>
      </form>
    </div>
  );
}

export default Speicals;
